import { Environment } from '../environments/environment';

/**
 * Console logger — active only in development/staging
 */
export class LoggerService {

  /**
   * True when the current environment permits logging
   * @returns {boolean} True in development or staging
   */
  private canLog(): boolean {
    const env = Environment.environment;
    return env === 'development' || env === 'staging';
  }

  /**
   * console.log wrapper
   * @param {any} message Log message
   * @param {any} params Extra params to include
   * @param {string} src Optional call-site tag
   * @returns {void}
   */
  log(message: any, params?: any, src?: string): void {
    if (this.canLog()) {
      console.log(`[LOG] ${message}`, {
        params: params || '',
        src: src || ''
      });
    }
  }

  // /**
  //  * Log information message
  //  * @param message Message to log
  //  * @param params Additional parameters
  //  */
  // info(message: any, params?: any, src?: string): void {
  //   if (this.canLog()) {
  //     console.info(`[INFO] ${message}`, ...params);
  //   }
  // }

  // /**
  //  * Log debug message
  //  * @param message Message to log
  //  * @param params Additional parameters
  //  */
  // debug(message: any, params?: any, src?: string): void {
  //   if (this.canLog()) {
  //     console.debug(`[DEBUG] ${message}`, ...params);
  //   }
  // }

  /**
   * console.warn wrapper
   * @param {any} message Warning message
   * @param {any} params Extra params to include
   * @param {string} src Optional call-site tag
   * @returns {void}
   */
  warn(message: any, params?: any, src?: string): void {
    if (this.canLog()) {
      console.warn(`[WARN] ${message}`, {
        params: params || '',
        src: src || ''
      });
    }
  }

  /**
   * console.error wrapper
   * @param {any} message Error message
   * @param {any} params Extra params to include
   * @param {string} src Optional call-site tag
   * @returns {void}
   */
  error(message: any, params?: any, src?: string): void {
    if (this.canLog()) {
      console.error(`[ERROR] ${message}`, {
        params: params || '',
        src: src || ''
      });
    }
  }

  // /**
  //  * Log table data
  //  * @param tabularData Table data to log
  //  * @param properties Optional properties
  //  */
  // table(tabularData: any, properties?: any, src?: string): void {
  //   if (this.canLog()) {
  //     console.table(tabularData, properties);
  //   }
  // }

  // /**
  //  * Log trace information
  //  * @param message Message to log
  //  * @param params Additional parameters
  //  */
  // trace(message: any, params?: any, src?: string): void {
  //   if (this.canLog()) {
  //     console.trace(`[TRACE] ${message}`, ...params);
  //   }
  // }
}
